module.exports = __webpack_public_path__ + "img/outline.7eb7136a.svg";